<template>
  <div>
    <p style="font-size: 100%">
      <b>Spare Parts</b> - Below is a list of Spare Parts associated with this
      Asset so your team can easily know what Parts to use on this Asset. Part
      associations are built automatically
    </p>
    <br />
    <vs-row>
      <vs-icon icon="inbox" />
      <p>417 Parts | ฿ 1,500,000</p>
      <vs-spacer></vs-spacer>
      <vs-input
        class="ml-2"
        icon-after="true"
        icon="search"
        placeholder="What are you looking for?"
        v-model="value1"
      />
      <vs-button
        radius
        class="mb-2 mr-2"
        color="#FF8800"
        type="line"
        icon="picture_as_pdf"
        style="float: right"
      />
      <vs-button
        radius
        class="mb-2 mr-2"
        color="primary"
        type="line"
        icon="download"
        icon-color="red"
        style="float: right"
      />
    </vs-row>
    <br />
    <vs-card style="border-radius: 20px">
      <vs-row>
        <vs-icon icon="inbox"></vs-icon>
        <h5 class="mt-1 ml-2">Associated Parts</h5>
      </vs-row>
      <br>
      <b-table  hover :items="items" :fields="fields" ></b-table>
      <br>
      <vs-divider></vs-divider>
      <br>
      <vs-button icon="add" style="border-radius: 20px" v-b-modal.PickParts
        >Add Parts</vs-button
      >
      <br /><br />
    </vs-card>

    <b-modal id="PickParts" centered size="lg" title="Pick Parts">
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>

      <template>
        <vs-table search :data="partdata" hoverFlat="false">
          <template slot="header">
            <h4>Select Parts eeded for this Work Order</h4>
          </template>
          <template slot="thead">
            <vs-th>
              <input
                type="checkbox"
                v-model="selectSparePart"
                @click="SelectPart"
              />
            </vs-th>
            <vs-th
              v-for="(item, indextr) in sparepartheader"
              :key="indextr"
              sort-key="name"
              id="noWrap"
            >
              {{ item }}
              <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
            </vs-th>
          </template>

          <template slot-scope="{ data }">
            <!-- <vs-tr
              id="fontSizedata"
              :class="{ opened: opened.includes(indextr) }"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            > -->
            <vs-tr
              id="fontSizedata"
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td>
                <!-- @click="select(), toggle(indextr)" -->
                <input
                  type="checkbox"
                  :value="data[indextr]"
                  v-model="SelectedPart"
                />
              </vs-td>

              <vs-td :data="data[indextr].PartName">{{
                data[indextr].PartName
              }}</vs-td>
              <vs-td :data="data[indextr].Qty">{{ data[indextr].Qty }}</vs-td>
              <vs-td :data="data[indextr].Cost">{{ data[indextr].Cost }}</vs-td>
              <vs-td>
                <vs-input-number min="13" max="21" v-model="number1" />
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      number1: 0,
      sparepartheader: ["PartName", "Qty", "Cost", "Pick"],
      partdata: [
        { PartName: "Olive Oil", Qty: 20, Cost: 1500 },
        { PartName: "Olive Oil2", Qty: 20, Cost: 1500 },
        { PartName: "Olive Oil3", Qty: 20, Cost: 1500 },
      ],
      // fields: ["Name", "Location_Name", "Part_Number","Price","Vendor"],
      fields: [
        {
          key: "Name",
          sortable: true,
        },
        {
          key: "Location_Name",
          sortable: true,
        },
        {
          key: "Part_Number",
          sortable: true,
        },
        {
          key: "Price",
          sortable: true,
        },
        {
          key: "Vendor",
          sortable: true,
        },
      ],
      items: [
        { Name: "testPP", Location_Name: 'Dickerson', Part_Number: '123412', Price:2000, Vendor:"R3N"},
        // { age: 21, first_name: 'Larsen', last_name: 'Shaw' },
        // { age: 89, first_name: 'Geneva', last_name: 'Wilson' },
        // { age: 38, first_name: 'Jami', last_name: 'Carney' }
      ],
    };
  },
};
</script>

<style></style>
